import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var styledLabel = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_uufmxu0',variantClassNames:{size:{'default':'fx_2d2fb1e5_uufmxu1',xlarge:'fx_2d2fb1e5_uufmxu2'}},defaultVariants:{},compoundVariants:[]});

export { styledLabel };
//# sourceMappingURL=label.vanilla.mjs.map
